// extracted by mini-css-extract-plugin
module.exports = {"SuperchargeSectionStatusC":"SuperchargeSectionStatusC_SuperchargeSectionStatusC__MPpD4","ef-box":"SuperchargeSectionStatusC_ef-box__JHNP5"};